export class FibuKonto {
    fibu_konto_id: number;
    konto_nr: string;
    bezeichnung: string;
    konto_typ: number;
    konto_typ_label: string;
    konto_art: string;
    sachkonto: string;
    kostenstelle_suffix: string;
    aktiv: number;
    kommentar: string;
    erstellt: Date;
    editiert: Date;
    mandant_id: number;
}

/** Anzeige-Labels für konto_typ */
export const FIBU_KONTO_TYPEN: { value: number; label: string }[] = [
    { value: 1, label: 'Aufwand' },
    { value: 2, label: 'Ertrag' },
    { value: 3, label: 'Bestand' },
    { value: 4, label: 'Sonstig' },
    { value: 5, label: 'Kreditor' },
    { value: 6, label: 'Debitor' },
];
